import {Component, EventEmitter, Input, NgZone, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ParksHandlerService} from '../../../../api-handlers/parks-handler.service';
import {ParkType} from '../../../../models/parkType';
import {UsersAdministrateParksHandlerService} from '../../../../api-handlers/users-administrate-parks-handler.service';

@Component({
	selector: 'app-create-park',
	templateUrl: './create-park.component.html',
	styleUrls: ['./create-park.component.css']
})
export class CreateParkComponent implements OnInit {
	@Output() created = new EventEmitter();
	form: FormGroup;
  parkTypes: ParkType[];
	errorMessage = '';
	success = false;
	loading = false;
	submitted = false;

	constructor(
		private formBuilder: FormBuilder,
		private parkService: ParksHandlerService,
    private userAdministrateParkService : UsersAdministrateParksHandlerService,
    private ngZone: NgZone
	) { }

	ngOnInit() {
		this.resetForm();
		this.reload();
	}

  reload() {
    this.reloadParkTypes();

  }

  reloadParkTypes() {
    this.parkService.getParkTypes().then((parkTypes: ParkType[]) => {
      this.ngZone.run(() => {
        this.parkTypes = parkTypes;
      });
    });
  }

	resetForm() {
		this.form = this.formBuilder.group({
			name: ['', [Validators.required, Validators.minLength(5)]],
			type: [1, [Validators.required, Validators.min(1)]],
		});

		this.submitted = false;
		this.loading = false;

	}

	get cp() { return this.form.controls; }

	onSubmit() {
		this.submitted = true;
		this.errorMessage = '';

		if (this.form.invalid) {
			return;
		}

		this.loading = true;
		this.parkService.createPark(this.cp.name.value, this.cp.type.value).then(
				data => {
					this.resetForm();
					this.created.next(undefined);
					this.success = true;
					setTimeout(() => {this.success = false; }, 2000);
					this.userAdministrateParkService.newPark();
				},
			err => {
				this.errorMessage = 'Impossibile creare il parco auto';
				this.loading = false;
			}).catch(
			error => {
				this.errorMessage = 'Impossibile creare il parco auto';
				this.loading = false;
			});
	}
}
